<template>

<div class="shell">
<!-- TOP BAR -->
<header class="topbar d-flex align-items-center justify-content-between py-1">
  <div class="topbar-left">
    <div class="toolbar-title">Consent Dashboard </div>
  </div>
<div class="topbar-right">
  <button class="filter-btn py-0" @click="goBack">
    <i class="fas fa-arrow-left"></i>
    Back
  </button>
</div>

</header>

<!-- VITAL STRIP -->
<div class="vital-strip" v-if="consentCounts">
  <div class="vital-inner">
    <div class="vital-item">
      <div class="vital-label">
        <span class="pulse" style="background:rgb(97 138 215);"></span>Total subjects
      </div>
      <div class="vital-val v-total">{{ consentCounts.all }}</div>
      <div class="vital-sub">Across Sites</div>
    </div>

    <div class="vital-item">
      <div class="vital-label">
        <span class="pulse" style="background:rgb(0 149 106);"></span>Consent signed
      </div>
      <div class="vital-val v-ok">{{ consentCounts.consented }}</div>
      <div class="vital-sub">
        {{ consentCounts.all > 0 ? Math.round((consentCounts.consented / consentCounts.all) * 100) : 0 }}% of total
      </div>
    </div>

    <div class="vital-item">
      <div class="vital-label">
        <span class="pulse" style="background:rgb(124, 58, 237);"></span>Re-consent due
      </div>
      <div class="vital-val v-reconsent">{{ consentCounts.reConsentDue }}</div>
      <div class="vital-sub">Amendment</div>
    </div>
      <div class="vital-item">
      <div class="vital-label">
        <span class="pulse" style="background:rgb(217,119,6);"></span>Pending
      </div>
      <div class="vital-val v-pending">{{ consentCounts.pending }}</div>
      <div class="vital-sub">Pending Consent</div>
    </div>

    <div class="vital-item">
      <div class="vital-label">
        <span class="pulse" style="background:rgb(253, 57, 57);"></span>Dissented
      </div>
      <div class="vital-val v-declined">{{ consentCounts.dissented }}</div>
      <div class="vital-sub">Screen Failed</div>
    </div>
  </div>
</div>


<!-- MAIN -->
<div class="main">

  <!-- SIDEBAR -->
  <aside class="sidebar">
    <div class="sidebar-section">
        <!-- <div class="study-chip mb-2">ICF v3.0 active</div> -->
      <div class="sidebar-label">Campaign</div>
    <div class="nav-item"
     :class="{ active: currentFilter === 'all' }"
     @click="setFilter('all')">
  <!-- All Subjects Icon -->
  <svg viewBox="0 0 15 15" fill="none">
    <rect x="1" y="1" width="13" height="13" rx="2" stroke="currentColor" stroke-width="1.2"/>
    <path d="M4 7.5h7M4 5h7M4 10h4" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
  </svg>
  All Subjects
  <span class="nav-badge green">{{ chipCounts.all }}</span>
</div>
   <div class="nav-item"
     :class="{ active: currentFilter === 'consented' }"
     @click="setFilter('consented')">
  <!-- Consent Signed Icon -->
  <svg viewBox="0 0 15 15" fill="none">
    <circle cx="7.5" cy="7.5" r="6" stroke="currentColor" stroke-width="1.2"/>
    <path d="M5 7.5l2 2 3-3" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
  Consent Signed
  <span class="nav-badge green">{{ chipCounts.consented }}</span>
</div>
     <div class="nav-item"
     :class="{ active: currentFilter === 'pending' }"
     @click="setFilter('pending')">
  <!-- Pending Icon -->
  <svg viewBox="0 0 15 15" fill="none">
    <circle cx="7.5" cy="7.5" r="6" stroke="currentColor" stroke-width="1.2"/>
    <path d="M7.5 4.5v3.5l2 1" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
  </svg>
  Pending
  <span class="nav-badge">{{ chipCounts.pending }}</span>
</div>
   <div class="nav-item"
     :class="{ active: currentFilter === 'dissented' }"
     @click="setFilter('dissented')">
  <!-- Dissented Icon -->
  <svg viewBox="0 0 15 15" fill="none">
    <circle cx="7.5" cy="7.5" r="6" stroke="currentColor" stroke-width="1.2"/>
    <path d="M7.5 5v3M7.5 10v.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
  </svg>
  Dissented
  <span class="nav-badge">{{ chipCounts.dissented }}</span>
</div>
    <div class="nav-item"
       :class="{ active: currentFilter === 'reconsent' }"
       @click="setFilter('reconsent')">
    <svg viewBox="0 0 15 15" fill="none">
      <circle cx="7.5" cy="7.5" r="6" stroke="currentColor" stroke-width="1.2"/>
      <path d="M5 7.5l2 2 3-3" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    Re-consent due
    <span class="nav-badge purple">{{ chipCounts.reconsent }}</span>
  </div>
<div class="nav-item"
     :class="{ active: currentFilter === 'not-started' }"
     @click="setFilter('not-started')">
  <svg viewBox="0 0 15 15" fill="none">
    <circle cx="7.5" cy="7.5" r="6" stroke="currentColor" stroke-width="1.2"/>
    <path d="M7.5 4.5v3.5l2 1" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
  </svg>
  Not Started
  <span class="nav-badge">{{ chipCounts['not-started'] }}</span>
</div>
    </div>
    <div class="sidebar-divider"></div>
 <div class="sidebar-section">
  <div class="sidebar-label">ICF Versions</div>
  <div
    class="nav-item"
    v-for="form in icfForms"
    :key="form.id"
  >
    <svg viewBox="0 0 15 15" fill="none">
      <rect x="2" y="1" width="11" height="13" rx="1.5" stroke="currentColor" stroke-width="1.2"/>
      <path d="M5 5h5M5 7.5h5M5 10h3" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
    </svg>
    <span class="nav-item-text">{{ form.version }} ({{ form. title }})</span>

  </div>
</div>

    <div class="sidebar-divider"></div>
<div class="campaign-card" v-if="campaign">
  <div class="campaign-title">{{ campaign.name }}</div>
  <div class="nav-item-text">
   {{ campaign.icf }}
  </div>
  <div class="campaign-prog">
    <div class="campaign-prog-bar" :style="{ width: campaign.percent + '%' }"></div>
  </div>
  <div class="campaign-prog-label">
    {{ campaign.consented }} of {{ campaign.total }} re-consented ({{ campaign.percent }}%)
  </div>
</div>

  </aside>

  <!-- CONTENT -->
  <main class="content">

    <!-- TOOLBAR -->
    <div class="toolbar">
      <div class="toolbar-title">Subject Consent Register</div>
      <div class="search-wrap">
        <svg class="search-icon" width="13" height="13" viewBox="0 0 13 13" fill="none"><circle cx="5.5" cy="5.5" r="4" stroke="#5B6A8A" stroke-width="1.3"/><path d="M9 9l2.5 2.5" stroke="#5B6A8A" stroke-width="1.3" stroke-linecap="round"/></svg>
            <input v-model="currentSearch" class="search-input" id="searchInput" placeholder="Search Subject ID" oninput="filterTable()">            
      </div>
    <button
  class="filter-btn"
  :disabled="isExporting"
  @click="exportCSV(true)"
>
  <!-- Show spinner while exporting, otherwise show the SVG icon -->
  <span v-if="isExporting" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
  <svg v-else width="13" height="13" viewBox="0 0 13 13" fill="none">
    <path d="M6.5 1v8M3.5 6l3 3 3-3" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M1 10.5h11" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/>
  </svg>
  Export   <!-- text stays the same always -->
</button>
      <!-- <button class="action-btn" onclick="sendAll()">
        <svg width="13" height="13" viewBox="0 0 13 13" fill="none"><path d="M1 6.5L11.5 1 8 12l-2-4-4-1.5z" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/></svg>
        Send reminders
      </button> -->
    </div>

    <!-- FILTER CHIPS -->
<div class="filter-chips">
  <div
    class="chip all"
    :class="{ sel: currentFilter === 'all' }"
    @click="setFilter('all')"
  >
    <span class="chip-dot" style="background:rgba(97,138,215)"></span>
    All ({{ chipCounts.all }})
  </div>

  <div
    class="chip consented"
    :class="{ sel: currentFilter === 'consented' }"
    @click="setFilter('consented')"
  >
    <span class="chip-dot" style="background:rgb(0,149,106)"></span>
    Consented ({{ chipCounts.consented }})
  </div>

  <div
    class="chip pending"
    :class="{ sel: currentFilter === 'pending' }"
    @click="setFilter('pending')"
  >
    <span class="chip-dot" style="background:rgba(217,119,6)"></span>
    Pending ({{ chipCounts.pending }})
  </div>

<div
  class="chip reconsent"
  :class="{ sel: currentFilter === 'reconsent' }"
  @click="setFilter('reconsent')"
>
  <span class="chip-dot" style="background:rgba(124,58,237)"></span>
  Re-consent due ({{ chipCounts.reconsent }})
</div>


  <div
    class="chip dissented"
    :class="{ sel: currentFilter === 'dissented' }"
    @click="setFilter('dissented')"
  >
    <span class="chip-dot" style="background:rgba(224,38,38)"></span>
     Dissented ({{ chipCounts.dissented }})
  </div>
    <div
    class="chip not-started"
    :class="{ sel: currentFilter === 'not-started' }"
    @click="setFilter('not-started')"
  >
    <span class="chip-dot" style="background:#5B6A8A;"></span>
     Not Started ({{ chipCounts['not-started'] }})
  </div>
</div>



    <!-- TABLE -->
<div class="table-wrap">
  <div class="table-scroll">
    <table id="subjectTable" class="table table-striped">
   <thead>
  <tr>
    <th style="width:6%;">Site Code</th>
    <th style="width:8%;">Subject ID</th>
    <th style="width:6%;">ICF Version</th>
    <th style="width:11%;">Consent Status</th>
    <th style="width:14%;">Consent Process Status</th>
    <th style="width:11%;">Subject Signed Date</th>
    <th style="width:12%;">Investigator Signed Date</th>
    <th style="width:14%;">Investigator</th>
    <th style="width:6%;">Re-Consent</th>
    <th style="width:7%;">Days Open</th>
    <th class="text-center" style="width:5%;">Actions</th>
  </tr>
</thead>
      <tbody>
        <tr v-for="s in filteredSubjects" :key="s.patientId">   
             <td class="td-site">{{ s.siteCode}}</td>
          <td class="td-id">{{ s.subjectId}}</td>
         
          <td class="td-site">{{ s.icfVersion}}</td>   
          <td>
  <span
    v-if="s.consentOutcome && s.consentOutcome"
    class="badge"
    :class="statusConfig[s.outcome]?.cls || 'badge-secondary'"
  >
    {{ s.consentOutcome }}
  </span>
  <span v-else style="color:var(--text3);font-size:11px;"></span>
</td>
 <td class="td-site">{{ s.consentStatus}}</td> 

        <!-- <td>
  <span
    class="badge"
    :class="statusConfig[s.outcome]?.cls || 'badge-secondary'"
  >
   
    {{ s.consentOutcome}}
  </span>
</td> -->


          <td>{{ s.signedDate}}</td>    

          <td>{{ s.investigatorSignedDate}}</td>
          <td>{{ s.investigatorEmail}}</td>

          <td>
            <span
              v-if="s.reconsent === 'Required'"
              style="color: var(--purple); font-size: 11px; font-weight: 500;"
            >
              Required
            </span>
            <span v-else style="color:var(--text3);font-size:11px;"></span>
          </td>
         <td>
  <span
    v-if="s.daysOpen > 0"
    :style="{
      color:
        s.daysOpen > 14
          ? 'var(--red)'
          : s.daysOpen > 7
          ? 'var(--amber)'
          : 'var(--text2)',
      fontSize: '11px',
      fontWeight: 500
    }"
  >
    {{ s.daysOpen }} days
  </span>
  <span v-else style="color:var(--text3)"></span>
</td>

       <td class="text-center">
<div class="row-actions d-flex justify-content-center">

  <div class="tooltip-wrapper">
    <button class="ra-btn ra-view" @click="viewSubject(s.patientId)">
      View
    </button>
    <div class="tool-tip">
      View consent record
    </div>
  </div>

  <div
    v-if="s.consentOutcome === 'Pending' && !s.subjectSignedDate"
    class="tooltip-wrapper"
  >
    <button class="ra-btn ra-send"  @click="resendNotification(s.patientId)">
      Resend
    </button>
    <div class="tool-tip">
      Resend mail notification
    </div>
  </div>

</div>
</td>

        </tr>
      </tbody>
    </table>
  </div>

  <div
    class="col-md-12 d-flex justify-content-md-end px-0"
    v-if="subjects.length != 0"
  >
    <VPagination
      v-model="currentPage"
      :pages="totalPages"
      :range-size="1"
      active-color="#ededed"
      @update:modelValue="loadPage"
    />
  </div>
</div>

  </main>
</div>
</div>

</template>

<script src="./eConsentDashboard.js"></script>

<style scoped>

.shell {
  font-family: inter, sans-serif;
  background: #F0F4F8;
  color: #1A2236;
  min-height: 100vh;
  margin: 0px -15px;
}

/* ── LAYOUT ── */
.shell {
    display: grid;
    grid-template-rows: auto auto 1fr;
    min-height: 100vh;
}

/* ── TOP BAR ── */
.topbar {
    background: rgb(240 244 248);
    border-bottom: 1px solid #D8E0EC;
    padding: 0 14px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0 1px 3px rgba(0, 0, 0, .06);
}

.topbar-left {
    display: flex;
    align-items: center;
    gap: 16px;
}

.logo {
    display: flex;
    align-items: center;
    gap: 8px;
}

.logo-mark {
    width: 28px;
    height: 28px;
    background: #00956A;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 1px 3px rgba(0, 149, 106, .3);
}

.logo-mark svg {
    width: 16px;
    height: 16px;
}

.logo-name {
    font-size: 14px;
    font-weight: 700;
    letter-spacing: -.3px;
    color: #1A2236;
}

.logo-name span {
    color: #00956A;
}

.topbar-sep {
    width: 1px;
    height: 20px;
    background: #C5D0E0;
}

.study-chip {
    font-size: 11px;
    font-weight: 500;
    color: #4A5A78;
    background: #F5F7FA;
    border: 1px solid #D8E0EC;
    border-radius: 20px;
    padding: 3px 10px;
    font-family: monospace;
}

.topbar-right {
    display: flex;
    align-items: center;
    gap: 10px;
}

.user-chip {
    display: flex;
    align-items: center;
    gap: 7px;
    font-size: 12px;
    color: #4A5A78;
}

.avatar {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: linear-gradient(135deg, #3B82F6, #A78BFA);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: 600;
    color: #fff;
}

.notif-btn {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    border: 1px solid #D8E0EC;
    background: #F5F7FA;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
    color: #4A5A78;
}

.notif-dot {
    position: absolute;
    top: 6px;
    right: 6px;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: rgba(217,119,6,.12);
    border: 1px solid #FFFFFF;
}

/* ── VITAL STRIP ── */
.vital-strip {
    background: #FFFFFF;
    border-bottom: 1px solid #D8E0EC;
    padding: 8px 22px;
    top:10px;
}

.vital-inner {
    display: flex;
    align-items: stretch;
    gap: 0;
    min-width: 640px;
    height: 60px;
}

.vital-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 20px;
    border-right: 1px solid #D8E0EC;
    gap: 2px;
    white-space: nowrap;
}

.vital-item:last-child {
    border-right: none;
}

.vital-item:first-child {
    padding-left: 0;
}

.vital-label {
    font-size: 10px;
    font-weight: 500;
    color: #8A96B0;
    letter-spacing: .6px;
    text-transform: uppercase;
}

.vital-val {
    font-size: 20px;
    font-weight: 700;
    letter-spacing: -1px;
    font-family: monospace;
}

.vital-sub {
    font-size: 10px;
    color: #8A96B0;
}

.v-total {
    color: #3ca0fd;
}

.v-ok {
    color: #00956A;
}

.v-pending {
    color: #D97706;
}

.v-declined {
    color: rgba(217,119,6);
}

.v-reconsent {
    color: rgba(126,60,237);
}

.v-overdue {
    color: rgba(217,119,6);
}

.pulse {
    display: inline-block;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    margin-right: 4px;
    animation: pulse 2s ease infinite;
}

@keyframes pulse {

    0%,
    100% {
        opacity: 1;
        transform: scale(1);
    }

    50% {
        opacity: .5;
        transform: scale(.85);
    }
}

/* ── MAIN CONTENT ── */
.main {
    display: grid;
    grid-template-columns: 220px 1fr;
    min-height: 0;
}

/* ── SIDEBAR ── */
.sidebar {
    background: #FFFFFF;
    border-right: 1px solid #D8E0EC;
    padding: 16px 0;
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.sidebar-section {
    padding: 0 12px;
    margin-bottom: 6px;
}

.sidebar-label {
    font-size: 10px;
    font-weight: 600;
    letter-spacing: .8px;
    text-transform: uppercase;
    color: #8A96B0;
    padding: 0 8px;
    margin-bottom: 4px;
}

.nav-item {
    display: flex;
    align-items: center;
    gap: 9px;
    padding: 7px 12px;
    border-radius: 8px;
    cursor: pointer;
    color: #4A5A78;
    font-size: 12px;
    font-weight: 500;
    transition: all .15s;
    margin: 0 8px;
}

.nav-item:hover {
    background: #F5F7FA;
    color: #1A2236;
}

.nav-item.active {
    background: rgba(0,149,106,.10);
    color: #00956A;
}
.active {
    opacity: 1;
    pointer-events: auto;
    position: relative;}
.nav-item svg {
    width: 15px;
    height: 15px;
    flex-shrink: 0;
}

.nav-badge {
    margin-left: auto;
    font-size: 10px;
    font-weight: 600;
    background: rgba(217,119,6,.12);
    color: #D97706;
    border-radius: 20px;
    padding: 2px 7px;
    font-family: monospace;
}

.nav-badge.green {
    background: rgba(0,149,106,.10);
    color: #00956A;
}

.sidebar-divider {
    height: 1px;
    background: #D8E0EC;
    margin: 8px 20px;
}

.campaign-card {
    margin: 8px 12px;
    background: #F5F7FA;
    border: 1px solid #D8E0EC;
    border-radius: 8px;
    padding: 10px 12px;
}

.campaign-title {
    font-size: 11px;
    font-weight: 600;
    color: #1A2236;
    margin-bottom: 4px;
}

.campaign-sub {
    font-size: 10px;
    color: #8A96B0;
    line-height: 1.5;
}

.campaign-prog {
    height: 3px;
    background: #D8E0EC;
    border-radius: 3px;
    margin-top: 8px;
    overflow: hidden;
}

.campaign-prog-bar {
    height: 100%;
    background: #00956A;
    border-radius: 3px;
    width: 62%;
}

.campaign-prog-label {
    font-size: 10px;
    color: #8A96B0;
    margin-top: 4px;
}

/* ── CONTENT AREA ── */
.content {
    padding: 10px 14px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 16px;
}
.tooltip-wrapper {
  position: relative;
  display: inline-block;
}

.tool-tip {
  display: none;
  position: absolute;
  bottom: 100%;
  left: 6%;
  transform: translateX(-50%);
  white-space: nowrap;
  padding: 5px 10px;
  font-size: 12px;
  background: #333;
  color: #fff;
  border-radius: 4px;
  z-index: 10;
  margin-bottom: 6px;
}

.tooltip-wrapper:hover .tool-tip {
  display: block;
}

/* ── TOOLBAR ── */
.toolbar {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

.toolbar-title {
    font-size: 15px;
    font-weight: 700;
    color: #1A2236;
    flex: 1;
    min-width: 180px;
}

.toolbar-title span {
    color: #8A96B0;
    font-weight: 400;
    font-size: 13px;
    margin-left: 6px;
}

.search-wrap {
    position: relative;
}

.search-input {
    background: #F5F7FA;
    border: 1px solid #D8E0EC;
    border-radius: 8px;
    padding: 4px 12px 4px 32px;
    color: #1A2236;
    font-size: 12px;
    font-family: inter, sans-serif;
    width: 220px;
    outline: none;
    transition: border .15s;
}

.search-input::placeholder {
    color: #8A96B0;
}

.search-input:focus {
    border-color: #00956A;
}

.search-icon {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: #8A96B0;
}

.filter-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    background: #F5F7FA;
    border: 1px solid #D8E0EC;
    border-radius: 8px;
    padding: 4px 12px;
    color: #4A5A78;
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    white-space: nowrap;
    transition: all .15s;
}

.filter-btn:hover,
.filter-btn.active {
    border-color: #00956A;
    color: #00956A;
}

.filter-btn svg {
    width: 13px;
    height: 13px;
}

.action-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    background: #00956A;
    border: none;
    border-radius: 8px;
    padding: 4px 14px;
    color: #FFFFFF;
    font-size: 12px;
    font-weight: 700;
    cursor: pointer;
    white-space: nowrap;
}
.nav-item-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
    flex: 1;
    font-size:11px;
}

/* ── FILTER CHIPS ── */
.filter-chips {
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
}

.chip {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 0px 10px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 500;
    cursor: pointer;
    border: 1px solid transparent;
    transition: all .15s;
}

.chip.all {
    background: rgba(0,149,255,.14);
    color: #0385db;
}
.chip.all:hover,
.chip.all.sel {
    border-color: #0385db;
}


.chip.consented {
    background: rgba(0,149,106,.10);
    color: #00956A;
}

.chip.consented:hover,
.chip.consented.sel {
    border-color: #00956A;
}

.chip.pending {
    background: rgba(217,119,6,.12);
    color: #D97706;
}

.chip.pending:hover,
.chip.pending.sel {
    border-color: #D97706;
}

.chip.reconsent {
    background: rgba(124,58,237,.10);
    color: rgba(124,58,237);
}

.chip.reconsent:hover,
.chip.reconsent.sel {
    border-color: rgba(124,58,237,1);
}

.chip.dissented {
    background: rgba(220,38,38,.10);
    color: rgba(220,38,38);
}

.chip.dissented:hover,
.chip.dissented.sel {
    border-color: rgba(220,38,38,1);
}

.chip.overdue {
    background: rgba(220,38,38,.10);
    color: rgba(220,38,38);
}

.chip.overdue:hover,
.chip.overdue.sel {
    border-color: rgba(217,119,6,.12);
}

.chip-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    flex-shrink: 0;
}

/* ── TABLE ── */
#subjectTable td {
    padding: 6px 6px;
    vertical-align: middle;
}

#subjectTable th {
    padding: 8px 6px;
    background: #abcdff;
}

#subjectTable {
    -table-layout: fixed;
    width: 100%;
}




.table-wrap {
    background: #FFFFFF;
    border: 1px solid #D8E0EC;
    border-radius: 8px;
    overflow: hidden;
}

.table-scroll {
    max-height: 450px;   /* adjust height as needed */
    overflow-y: auto;
    overflow-x: auto;
}
#subjectTable thead th {
    position: sticky;
    top: 0;
    background: #abcdff;
    z-index: 5;
}
#subjectTable {
    width: 100%;
    -min-width: 1200px;   /* keeps horizontal scroll if needed */
}

.table {
    width: 100%;
    border-collapse: collapse;
}

.thead tr {
    background: #F5F7FA;
    border-bottom: 1px solid #D8E0EC;
}

.th {
    padding: 10px 14px;
    text-align: left;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: .6px;
    text-transform: uppercase;
    color: #8A96B0;
    white-space: nowrap;
    cursor: pointer;
    user-select: none;
}

th:hover {
    color: #4A5A78;
}

.th .sort-icon {
    margin-left: 4px;
    opacity: .4;
}

.th.sorted .sort-icon {
    opacity: 1;
    color: #00956A;
}

.tbody tr {
    border-bottom: 1px solid #D8E0EC;
    transition: background .1s;
    cursor: pointer;
}

.tbody tr:last-child {
    border-bottom: none;
}

.tbody tr:hover {
    background: #F5F7FA;
}

.tbody tr.selected {
    background: rgba(0,149,106,.06);
}

.td {
    padding: 11px 14px;
    font-size: 12px;
    color: #1A2236;
    vertical-align: middle;
    white-space: nowrap;
}

.td-id {
    font-family: monospace;
    font-size: 11px;
    color: #4A5A78;
}

.td-name {
    font-weight: 500;
}

.td-site {
    font-size: 11px;
    color: #4A5A78;
}

.td-date {
    font-family: monospace;
    font-size: 11px;
    color: #4A5A78;
}

/* status badges */
.badge {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 3px 9px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 500;
}

.badge .bdot {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    flex-shrink: 0;
}

.b-consented {
    background: rgba(0,149,106,.10);
    color: #00956A;
}

.b-consented .bdot {
    background: #00956A;
}

.b-pending {
    background: rgba(217,119,6,.12);
    color: #D97706;
}

.b-pending .bdot {
    background: #D97706;
    animation: pulse 2s ease infinite;
}
.chip.not-started {
  background: rgba(91, 106, 138, 0.15);
  color: #5B6A8A;
}
.chip.not-started:hover,
.chip.not-started.sel {
  border-color: #5B6A8A;
}
.b-notstarted {
    background: rgba(91, 106, 138, 0.15);
    color: #5B6A8A;
}
.b-notstarted .bdot {
    background: rgba(91, 106, 138, 0.15);
     animation: pulse 2s ease infinite;
}

.b-reconsent {
    background: rgba(124,58,237,.10);
    color: rgba(124,58,237);
}

.b-reconsent .bdot {
    background: rgba(124,58,237);
    animation: pulse 1.5s ease infinite;
}

.b-dissented {
    background: rgba(220,38,38,.30);
    color: rgb(255, 42, 42);
}

.b-dissented .bdot {
    background: rgb(255, 42, 42);
}

.b-overdue {
    background: rgba(220,38,38,.10);
    color: rgba(220,38,38);
}

.b-overdue .bdot {
    background: rgb(255, 94, 0);
    animation: pulse 1s ease infinite;
}

.b-withdrawn {
    background: rgba(91, 106, 138, .15);
    color: #8A96B0;
}

.b-withdrawn .bdot {
    background: #8A96B0;
}

/* icf ver */
.icf-ver {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-family: monospace;
    font-size: 11px;
    color: #4A5A78;
    background: #F5F7FA;
    border: 1px solid #D8E0EC;
    border-radius: 12px;
    padding: 0px 7px;
}

.icf-ver.latest {
    border-color: #00956A;
    color: #00956A;
    background: rgba(0,149,106,.06);
}

.icf-ver.old {
    border-color: #D97706;
    color: #D97706;
    background: rgba(217,119,6,.12);
}

/* actions */
.row-actions {
    display: flex;
    align-items: center;
    gap: 6px;
}

.tr:hover .row-actions {
    opacity: 1;
}

.ra-btn {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 2px 9px;
    border-radius: 6px;
    font-size: 10px;
    font-weight: 500;
    border: none;
    cursor: pointer;
    transition: all .15s;
}

.ra-view {
    background: #e2efff;
    color: #04a3ff;
}

.ra-view:hover {
    background: #04a3ff;
    color: #ffffff;
}

.ra-send {
    background: rgba(46, 202, 158, 0.11);
    color: #19a77e;
}

.ra-send:hover {
    background: #00956A;
    color: #FFFFFF;
}

.ra-flag {
    background: rgba(220,38,38,.10);
    color: rgba(217,119,6,.12);
}

/* table footer */
.table-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 14px;
    border-top: 1px solid #D8E0EC;
    background: #F5F7FA;
}

.tf-info {
    font-size: 11px;
    color: #8A96B0;
}

.tf-pages {
    display: flex;
    gap: 4px;
}

.pg-btn {
    width: 28px;
    height: 28px;
    border-radius: 6px;
    border: 1px solid #D8E0EC;
    background: #FFFFFF;
    color: #4A5A78;
    font-size: 11px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.pg-btn.active {
    background: #00956A;
    color: #FFFFFF;
    border-color: #00956A;
    font-weight: 600;
}

/* ── RESPONSIVE ── */
@media(max-width:900px) {
    .main {
        grid-template-columns: 1fr;
    }

    .sidebar {
        display: none;
    }
}

</style>
